<template>
<div>
<p>We hope you have enjoyed reading this book excerpt from the Center for Creative Leadership.  Please click on the store link to buy the book or a social link to share it.</p>
<p>Here are other books that you might enjoy:</p>
<div>
<div style="width: 32.33%; display: inline-block; margin: 0 1% 1% 0; vertical-align: top;"><a href="https://textcafe.co/books/Ary0yF/"><img alt="" src="https://s3.amazonaws.com/textcafe.epubs/uploads-image-covers/coresource/9781604916546.jpg" width="100%"/></a></div>
<div style="width: 32.33%; display: inline-block; margin: 0 1% 1% 0; vertical-align: top;"><a href="https://textcafe.co/books/p8zqgO/"><img alt="" src="https://s3.amazonaws.com/textcafe.epubs/uploads-image-covers/coresource/9781604918762.jpg" width="100%"/></a></div>
<div style="width: 32.33%; display: inline-block; margin: 0 1% 1% 0; vertical-align: top;"><a href="https://textcafe.co/books/Vjlkn7/"><img alt="" src="https://s3.amazonaws.com/textcafe.epubs/uploads-image-covers/coresource/9781604917321.jpg" width="100%"/></a></div>
<div style="width: 32.33%; display: inline-block; margin: 0 1% 1% 0; vertical-align: top;"><a href="https://textcafe.co/books/nbvuKH/"><img alt="" src="https://s3.amazonaws.com/textcafe.epubs/uploads-image-covers/coresource/9781604917314.jpg" width="100%"/></a></div>
</div>
</div>
</template>
<script>
export default {
  name: 'last',
  data() {
    return {}
    },
      components: {
    }
  }
</script>


// WEBPACK FOOTER //
// last.vue?fa362d62